import MobileDesktopSwitcher from 'components/MobileDesktopSwitcher/MobileDesktopSwitcher';
import WifiBottomPanelContainer from './WifiBottomPanel';
import WifiBottomPanelMobile from './WifiBottomPanelMobile';

const WifiBottomPanelResponsive = () => (
  <MobileDesktopSwitcher Desktop={WifiBottomPanelContainer} Mobile={WifiBottomPanelMobile} />
);

export default WifiBottomPanelResponsive;
